import { VHeaders } from '@/models/pagedlistmodel';
import { Base } from "@/components/common/base";

export function getTimingColumnsHeaders(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t('stores.timings.timingGridHeaders.days') as string,
      align: 'left',
      value: 'days',
      sortable: false,
    },
    {
      text: vm.$parent.$t('stores.timings.timingGridHeaders.from') as string,
      align: 'left',
      value: 'startTime',
      sortable: false,
    },
    {
      text: vm.$parent.$t('stores.timings.timingGridHeaders.to') as string,
      align: 'left',
      value: 'endTime',
      sortable: false,
    },
    {
      text: vm.$parent.$t('stores.timings.timingGridHeaders.action') as string,
      align: 'center',
      sortable: false,
      isNotDataProp: true,
    },
  ];
}

export function getPdiNewColumns(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t(
        'stores.pdiSettings.pdiGridHeaders.vehicleType'
      ) as string,
      align: 'left',
      value: 'VehicleType',
      sortable: false,
      filters: [
        () => {
          return 'New';
        },
      ],
    },
    {
      text: vm.$parent.$t(
        'stores.pdiSettings.pdiGridHeaders.serviceLineNumber'
      ) as string,
      align: 'left',
      value: 'serviceLineNumber',
      sortable: false,
    },
    {
      text: vm.$parent.$t(
        'stores.pdiSettings.pdiGridHeaders.sequenceNumber'
      ) as string,
      align: 'left',
      value: 'sequenceNumber',
      sortable: false,
    },
    {
      text: vm.$parent.$t(
        'stores.pdiSettings.pdiGridHeaders.serviceType'
      ) as string,
      align: 'left',
      value: 'serviceType',
      sortable: false,
    },
    {
      text: vm.$parent.$t(
        'stores.pdiSettings.pdiGridHeaders.laborOpCode'
      ) as string,
      align: 'left',
      value: 'laborOpCode',
      sortable: false,
    },
    {
      text: vm.$parent.$t(
        'stores.pdiSettings.pdiGridHeaders.lineType'
      ) as string,
      align: 'left',
      value: 'lineType',
      sortable: false,
    },
    {
      text: vm.$parent.$t(
        'stores.pdiSettings.pdiGridHeaders.transCode'
      ) as string,
      align: 'left',
      value: 'transCode',
      sortable: false,
    },
    {
      text: vm.$parent.$t('stores.pdiSettings.pdiGridHeaders.action') as string,
      align: 'center',
      sortable: false,
      isNotDataProp: true,
    },
  ];
}

export function getPdiUsedColumns(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t(
        'stores.pdiSettings.pdiGridHeaders.vehicleType'
      ) as string,
      align: 'left',
      value: 'VehicleType',
      filters: [
        () => {
          return 'Used';
        },
      ],
    },
    {
      text: vm.$parent.$t(
        'stores.pdiSettings.pdiGridHeaders.serviceLineNumber'
      ) as string,
      align: 'left',
      value: 'serviceLineNumber',
    },
    {
      text: vm.$parent.$t(
        'stores.pdiSettings.pdiGridHeaders.sequenceNumber'
      ) as string,
      align: 'left',
      value: 'sequenceNumber',
    },
    {
      text: vm.$parent.$t(
        'stores.pdiSettings.pdiGridHeaders.serviceType'
      ) as string,
      align: 'left',
      value: 'serviceType',
    },
    {
      text: vm.$parent.$t(
        'stores.pdiSettings.pdiGridHeaders.laborOpCode'
      ) as string,
      align: 'left',
      value: 'laborOpCode',
    },
    {
      text: vm.$parent.$t(
        'stores.pdiSettings.pdiGridHeaders.lineType'
      ) as string,
      align: 'left',
      value: 'lineType',
    },
    {
      text: vm.$parent.$t(
        'stores.pdiSettings.pdiGridHeaders.transCode'
      ) as string,
      align: 'left',
      value: 'transCode',
    },
    {
      text: vm.$parent.$t('stores.pdiSettings.pdiGridHeaders.action') as string,
      align: 'center',
      sortable: false,
      isNotDataProp: true,
    },
  ];
}

export function getPdiCPOColumns(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t(
        'stores.pdiSettings.pdiGridHeaders.vehicleType'
      ) as string,
      align: 'left',
      value: 'VehicleType',
      sortable: false,
      filters: [
        () => {
          return 'CPO';
        },
      ],
    },
    {
      text: vm.$parent.$t(
        'stores.pdiSettings.pdiGridHeaders.serviceLineNumber'
      ) as string,
      align: 'left',
      value: 'serviceLineNumber',
    },
    {
      text: vm.$parent.$t(
        'stores.pdiSettings.pdiGridHeaders.sequenceNumber'
      ) as string,
      align: 'left',
      value: 'sequenceNumber',
    },
    {
      text: vm.$parent.$t(
        'stores.pdiSettings.pdiGridHeaders.serviceType'
      ) as string,
      align: 'left',
      value: 'serviceType',
    },
    {
      text: vm.$parent.$t(
        'stores.pdiSettings.pdiGridHeaders.laborOpCode'
      ) as string,
      align: 'left',
      value: 'laborOpCode',
    },
    {
      text: vm.$parent.$t(
        'stores.pdiSettings.pdiGridHeaders.lineType'
      ) as string,
      align: 'left',
      value: 'lineType',
    },
    {
      text: vm.$parent.$t(
        'stores.pdiSettings.pdiGridHeaders.transCode'
      ) as string,
      align: 'left',
      value: 'transCode',
    },
    {
      text: vm.$parent.$t('stores.pdiSettings.pdiGridHeaders.action') as string,
      align: 'center',
      isNotDataProp: true,
      sortable: false,
    },
  ];
}

export function getPdiDealerTradeColumns(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t(
        'stores.pdiSettings.pdiGridHeaders.vehicleType'
      ) as string,
      align: 'left',
      value: 'VehicleType',

      filters: [
        () => {
          return 'Dealertrade';
        },
      ],
    },
    {
      text: vm.$parent.$t(
        'stores.pdiSettings.pdiGridHeaders.serviceLineNumber'
      ) as string,
      align: 'left',
      value: 'serviceLineNumber',
    },
    {
      text: vm.$parent.$t(
        'stores.pdiSettings.pdiGridHeaders.sequenceNumber'
      ) as string,
      align: 'left',
      value: 'sequenceNumber',
    },
    {
      text: vm.$parent.$t(
        'stores.pdiSettings.pdiGridHeaders.serviceType'
      ) as string,
      align: 'left',
      value: 'serviceType',
    },
    {
      text: vm.$parent.$t(
        'stores.pdiSettings.pdiGridHeaders.laborOpCode'
      ) as string,
      align: 'left',
      value: 'laborOpCode',
    },
    {
      text: vm.$parent.$t(
        'stores.pdiSettings.pdiGridHeaders.lineType'
      ) as string,
      align: 'left',
      value: 'lineType',
    },
    {
      text: vm.$parent.$t(
        'stores.pdiSettings.pdiGridHeaders.transCode'
      ) as string,
      align: 'left',
      value: 'transCode',
    },
    {
      text: vm.$parent.$t('stores.pdiSettings.pdiGridHeaders.action') as string,
      align: 'center',
      isNotDataProp: true,
      sortable: false,
    },
  ];
}

export function getVehicleLocationColumns(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t(
        'stores.vehicleLocations.locationGridHeaders.locationName'
      ) as string,
      align: 'center',
      value: 'locationName',
      sortable: false,
    },
    {
      text: vm.$parent.$t(
        'stores.vehicleLocations.locationGridHeaders.action'
      ) as string,
      align: 'center',
      sortable: false,
      isNotDataProp: true,
    },
  ];
}

export function getsquareLocationColumns(vm: any): VHeaders[] {
  return [
    {
      text: 'Name',
      align: 'center',
      value: 'name',
      sortable: false,
    },
    {
      text: 'Status',
      align: 'center',
      value: 'status',
      sortable: false,
    },
    {
      text: 'Code',
      align: 'center',
      value: 'code',
      sortable: false,
    },
    {
      text: 'DeviceId',
      align: 'center',
      value: 'deviceId',
      sortable: false,
    },
    {
      text: vm.$parent.$t(
        'stores.vehicleLocations.locationGridHeaders.action'
      ) as string,
      align: 'center',
      sortable: false,
      isNotDataProp: true,
    },
  ];
}


export function getPayrocTerminalColumns(vm: any): VHeaders[] {
  return [
    {
      text: 'Serial Number',
      align: 'center',
      value: 'serialNumber',
      sortable: false,
    },
    {
      text: 'Processing TerminalId',
      align: 'center',
      value: 'processingTerminalId',
      sortable: false,
    },
    {
      text: 'Device Friendly Name',
      align: 'center',
      value: 'deviceName',
      sortable: false,
    },
    {
      text: vm.$parent.$t(
        'stores.vehicleLocations.locationGridHeaders.action'
      ) as string,
      align: 'center',
      sortable: false,
      isNotDataProp: true,
    },
  ];
}

export function getvehicleWholesaleColumns(vm: any): VHeaders[] {
  return [
    {
      text: 'Sale Type Name',
      align: 'center',
      value: 'saleType',
      sortable: false,
    },
    {
      text: 'Sale Account',
      align: 'center',
      value: 'saleAccount',
      sortable: false,
    },
    {
      text: 'Cost Sale Account',
      align: 'center',
      value: 'costOfSaleAccount',
      sortable: false,
    },
    {
      text: 'Action',
      align: 'center',
      sortable: false,
      isNotDataProp: true,
    },
  ];
}
export function getFaxLineColumns(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t(
        'stores.faxLines.faxLineGridHeaders.faxNumber'
      ) as string,
      align: 'left',
      value: 'faxNumber',
      sortable: false,
    },
    {
      text: vm.$parent.$t(
        'stores.faxLines.faxLineGridHeaders.action'
      ) as string,
      align: 'center',
      sortable: false,
      isNotDataProp: true,
    },
  ];
}

export function getForwardingNumberColumns(vm: any): VHeaders[] {
  return [
    {
      text: 'Name',
      align: 'left',
      value: 'name',
      sortable: false,
    },
    {
      text: 'Alynk Number',
      align: 'left',
      value: 'alynkNumber',
      sortable: false,
    },
    {
      text: 'Forwarding Number',
      align: 'left',
      value: 'forwardingNumber',
      sortable: false,
    },
    {
      text: 'Action',
      align: 'center',
      sortable: false,
      isNotDataProp: true,
    },
  ];
}

export function getTaxCalculationColumns(vm: any): VHeaders[] {
  return [
    {
      text: 'Tax Name',
      align: 'left',
      value: 'taxName',
      sortable: false,
    },
    {
      text: 'Tax Rate',
      align: 'left',
      value: 'taxRate',
      sortable: false,
    },
    {
      text: 'Tax Payable Account',
      align: 'left',
      value: 'taxPayableAccount',
      sortable: false,
    },
    {
      text: 'Action',
      align: 'center',
      sortable: false,
      isNotDataProp: true,
    },
  ];
}

export function getStoreIpColumns(vm: any): VHeaders[] {
  return [
    {
      text: 'Name',
      align: 'left',
      value: 'name',
      sortable: false,
    },
    {
      text: 'Ip Range From',
      align: 'left',
      value: 'fromIp',
      sortable: false,
    },
    {
      text: 'Ip Range To',
      align: 'left',
      value: 'toIp',
      sortable: false,
    },
    {
      text: 'Action',
      align: 'center',
      sortable: false,
      isNotDataProp: true,
    },
  ];
}

export function getPresetAccountsColumns(vm: any): VHeaders[] {
  return [
    {
      text: 'Preset Name',
      align: 'left',
      value: 'name',
      sortable: false,
    },
    {
      text: 'Accounts',
      align: 'left',
      value: 'accountNumber',
      sortable: false,
    },
    {
      text: 'Action',
      align: 'center',
      sortable: false,
      isNotDataProp: true,
    }
  ];
}

export function getRefundPresetColumns(vm: any): VHeaders[] {
  return [
    {
      text: 'Name',
      align: 'left',
      value: 'name',
      sortable: false,
    },
    {
      text: 'Account Number',
      align: 'left',
      value: 'accountNumber',
      sortable: false,
    },
    // {
    //   text: 'Control Number',
    //   align: 'left',
    //   value: 'controlNumber',
    //   sortable: false,
    // },
    {
      text: 'Sections',
      align: 'left',
      value: 'identifiers',
      sortable: false,
    },
    {
      text: 'IsEnabled',
      align: 'left',
      value: 'isEnabled',
      sortable: false,
      fieldType: 'template',
      template: (item) => {
        if (item.isEnabled && item.isEnabled != false) {
          return `<span>${'Enabled'
            }</span>`;
        } else {
          return `<span>${'Disabled'
            }</span>`;
        }
      }

    },
    {
      text: 'Action',
      align: 'center',
      sortable: false,
      isNotDataProp: true,
    }
  ];
}
export function getDefaultVehicleServices(vm: any): VHeaders[] {
  return [
    {
      text: 'Name',
      align: 'left',
      value: 'name',
      sortable: false,
    },
    {
      text: 'Internal Name',
      align: 'left',
      value: 'internalName',
      sortable: false,
    },
    {
      text: 'Service Code',
      align: 'left',
      value: 'serviceCode',
      sortable: false,
    },


    {
      text: 'Action',
      align: 'center',
      sortable: false,
      isNotDataProp: true,
    }
  ];
}
export function getRfIdColumns(vm: any): VHeaders[] {
  return [
    {
      text: 'Reader Name',
      align: 'left',
      value: 'serverName',
      sortable: false,
    },
    {
      text: 'IpAddress',
      align: 'left',
      value: 'ipAddress',
      sortable: false,
    },
    {
      text: 'Antenna',
      align: 'left',
      value: 'antenna',
      sortable: false,
    },
    {
      text: 'Location Name',
      align: 'left',
      value: 'locationName',
      sortable: false,
    },
    {
      text: 'DMS Location Id',
      align: 'left',
      value: 'locationId',
      sortable: false,
    },
    {
      text: 'Connection Status',
      align: 'left',
      value: 'status',
      sortable: false,
    },
    {
      text: 'Error',
      align: 'left',
      value: 'error',
      sortable: false,
    },
    {
      text: 'IsEnabled',
      align: 'left',
      value: 'isEnabled',
      sortable: false,
      filters: [
        (val) => {
          if (val && val != false) {
            return 'Enabled';
          } else {
            return 'Disabled';
          }
        },
      ]
    },
    {
      text: 'Action',
      align: 'center',
      sortable: false,
      isNotDataProp: true,
    }
  ];
}

export function getStoreBuildingColumns(vm: any): VHeaders[] {
  return [
    {
      text: 'Name',
      align: 'left',
      value: 'value',
      sortable: false,
    },
    {
      text: 'Action',
      align: 'center',
      sortable: false,
      isNotDataProp: true,
    }
  ];
}


export function getVehicleInvoiceOptionsColumns(vm: any): VHeaders[] {
  return [
    {
      text: 'Description',
      align: 'left',
      value: 'description',
      sortable: false,
    },
    {
      text: 'Option Code',
      align: 'left',
      value: 'fieldValue',
      sortable: false,
    },
    {
      text: 'Action',
      align: 'center',
      sortable: false,
      isNotDataProp: true,
    },
  ];
}

export function getsipTrunkDetailsColumns(vm: any): VHeaders[] {
  return [
    {
      text: 'Name',
      align: 'left',
      value: 'name',
      sortable: false,
    },
    {
      text: 'Trunk Id',
      align: 'left',
      value: 'trunkId',
      sortable: false,
    },
    {
      text: 'Action',
      align: 'center',
      sortable: false,
      isNotDataProp: true,
    },
  ];
}

export function getPositivePayDetailsColumns(vm: any): VHeaders[] {
  return [
    {
      text: 'Bank Account Number',
      align: 'left',
      value: 'bankAccountNumber',
      sortable: false,
    },
    {
      text: 'DMS Bank Account Number',
      align: 'left',
      value: 'dmsBankAccountNumber',
      sortable: false,
    },
    {
      text: 'Action',
      align: 'center',
      sortable: false,
      isNotDataProp: true,
    },
  ];
}

export function getCustomReportDetailsColumns(vm: any): VHeaders[] {
  return [
    {
      text: 'Account Number',
      align: 'left',
      value: 'accountNumber',
      sortable: false,
    },
    {
      text: 'Action',
      align: 'center',
      sortable: false,
      isNotDataProp: true,
    },
  ];
}


export function getTechClassSetupColumns(vm: any): VHeaders[] {
  return [
    {
      text: 'Description',
      align: 'left',
      isNotDataProp: true,
      value: 'description',
      sortable: false,
    },
    {
      text: 'Class',
      align: 'left',
      value: 'techClass',
      sortable: false,
    },
    {
      text: 'Action',
      align: 'center',
      sortable: false,
      isNotDataProp: true,
    },
  ];
}

export function getStoreRunningNumberColumns(vm: any): VHeaders[] {
  return [
    {
      text: 'Record Key',
      align: 'left',
      value: 'recordIdentifier',
      sortable: true,
    },
    {
      text: 'Value',
      align: 'left',
      value: 'recordValue',
      sortable: false,
    },
    {
      align: 'left',
      text: 'Action',
      isNotDataProp: true,
      sortable: false,
    },
  ];
}





export function getFeatureColumns(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t(
        'stores.features.featureGridHeaders.feature'
      ) as string,
      align: 'left',
      value: 'key',
      sortable: false,
    },
    {
      text: vm.$parent.$t(
        'stores.features.featureGridHeaders.status'
      ) as string,
      align: 'left',
      value: 'status',
      sortable: false,
      filters: [
        (val) => {
          if (val) {
            return val.toUpperCase();
          }
        },
      ],
    },
  ];
}

export function getTemplateColumn(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t(
        'stores.templates.templateGridHeaders.templateName'
      ) as string,
      align: 'left',
      value: 'key',
    },
    {
      text: vm.$parent.$t(
        'stores.templates.templateGridHeaders.templateText'
      ) as string,
      align: 'left',
      value: 'text',
    },
    {
      text: vm.$parent.$t(
        'stores.templates.templateGridHeaders.action'
      ) as string,
      align: 'center',
      isNotDataProp: true,
      sortable: false,
    },
  ];
}

export function getShipmentProviderColumns(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t(
        'stores.shipmentProviders.shipmentProvidersHeaders.providerName'
      ) as string,
      align: 'left',
      value: 'providerName',
    },
    {
      text: vm.$parent.$t(
        'stores.shipmentProviders.shipmentProvidersHeaders.key'
      ) as string,
      align: 'left',
      value: 'key',
    },
    {
      text: vm.$parent.$t(
        'stores.shipmentProviders.shipmentProvidersHeaders.accountNumber'
      ) as string,
      align: 'left',
      value: 'accountNumber',
    },
    {
      text: vm.$parent.$t(
        'stores.shipmentProviders.shipmentProvidersHeaders.meterNumber'
      ) as string,
      align: 'left',
      value: 'meterNumber',
    },
    {
      text: vm.$parent.$t(
        'stores.shipmentProviders.shipmentProvidersHeaders.action'
      ) as string,
      align: 'center',
      isNotDataProp: true,
      sortable: false,
    },
  ];
}

export function getCrossCompanyPostingColumns(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t(
        'stores.crossCompanyPosting.crossCompanyHeaders.storeName'
      ) as string,
      align: 'left',
      value: 'storeName',
    },
    {
      text: vm.$parent.$t(
        'stores.crossCompanyPosting.crossCompanyHeaders.arAccount'
      ) as string,
      align: 'left',
      value: 'arAccount',
    },
    {
      text: vm.$parent.$t(
        'stores.crossCompanyPosting.crossCompanyHeaders.apAccount'
      ) as string,
      align: 'left',
      value: 'apAccount',
    },
    {
      text: vm.$parent.$t(
        'stores.crossCompanyPosting.crossCompanyHeaders.action'
      ) as string,
      align: 'center',
      isNotDataProp: true,
      sortable: false,
    },
  ];
}

export function getReadEmailColumns(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t('stores.readEmail.readEmailHeaders.host') as string,
      align: 'left',
      value: 'host',
    },
    {
      text: vm.$parent.$t('stores.readEmail.readEmailHeaders.port') as string,
      align: 'left',
      value: 'port',
    },
    {
      text: vm.$parent.$t('stores.readEmail.readEmailHeaders.ssl') as string,
      align: 'left',
      value: 'ssl',
    },
    {
      text: vm.$parent.$t(
        'stores.readEmail.readEmailHeaders.userName'
      ) as string,
      align: 'left',
      value: 'userName',
    },
    {
      text: vm.$parent.$t(
        'stores.readEmail.readEmailHeaders.password'
      ) as string,
      align: 'left',
      value: 'password',
    },
    {
      text: vm.$parent.$t(
        'stores.crossCompanyPosting.crossCompanyHeaders.action'
      ) as string,
      align: 'center',
      isNotDataProp: true,
      sortable: false,
    },
  ];
}

export function getCheckbookAccountColumns(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t(
        'stores.checkBookBankAccount.checkbookHeaders.name'
      ) as string,
      align: 'left',
      value: 'name',

      filters: [
        (val) => {
          if (val && val !== 'N/A') {
            return val;
          } else {
            return ' ';
          }
        },
      ],
    },
    {
      text: vm.$parent.$t(
        'stores.checkBookBankAccount.checkbookHeaders.id'
      ) as string,
      align: 'left',
      value: 'id',

      filters: [
        (val) => {
          if (val && val !== 'N/A') {
            return val;
          } else {
            return ' ';
          }
        },
      ],
    },
    {
      text: vm.$parent.$t(
        'stores.checkBookBankAccount.checkbookHeaders.status'
      ) as string,
      align: 'left',
      value: 'status',

      filters: [
        (val) => {
          if (val && val !== 'N/A') {
            return val;
          } else {
            return ' ';
          }
        },
      ],
    },
    {
      text: vm.$parent.$t(
        'stores.checkBookBankAccount.checkbookHeaders.type'
      ) as string,
      align: 'left',
      value: 'type',

      filters: [
        (val) => {
          if (val && val !== 'N/A') {
            return val;
          } else {
            return ' ';
          }
        },
      ],
    },
    {
      text: vm.$parent.$t(
        'stores.checkBookBankAccount.checkbookHeaders.date'
      ) as string,
      align: 'left',
      value: 'date',

      filters: [
        (val) => {
          if (val && val !== 'N/A') {
            return val;
          } else {
            return ' ';
          }
        },
      ],
    },
    {
      text: vm.$parent.$t(
        'stores.checkBookBankAccount.checkbookHeaders.action'
      ) as string,
      align: 'center',
      isNotDataProp: true,
      sortable: false,
    },
  ];
}

export function getWeOweConfigHeaders(vm: any): VHeaders[] {
  return [
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'stores.weOwe.weOweHeaders.dealFeeRecordType'
      ) as string,
      value: 'recordType',
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'stores.weOwe.weOweHeaders.dealFeeSequenceNumber'
      ) as string,
      value: 'sequenceNumber',
    },
    {
      align: 'center',
      sortable: false,
      isNotDataProp: true,
      text: vm.$parent.$t('stores.weOwe.weOweHeaders.action') as string,
      value: '',
    },
  ];
}

export function getStoreListHeaders(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t('stores.storeGridHeaders.dealershipName') as string,
      align: 'left',
      value: 'name',
    },
    {
      text: vm.$parent.$t('stores.storeGridHeaders.storeId') as string,
      align: 'left',
      value: 'glStoreId',
    },
    {
      text: vm.$parent.$t('stores.storeGridHeaders.action') as string,
      isNotDataProp: true,
      align: 'center',
      sortable: false,
    },
  ];
}
